import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { IDeleteButtonProps } from './deleteButtonPlainTextProps';
import Strings from '../../../i18n';

export const DeleteButtonPlainText = ({
  onDelete,
  textConfirmation,
  titleConfirmation,
  textIcon,
  showDeleteIcon,
  colorBtn
}: IDeleteButtonProps) => {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    handleClose();
  };

  return (
    <>
      <Button
        variant="outlined"
        color={colorBtn ?? 'error'}
        sx={{ width: '100%', justifyContent: 'space-between' }}
        onClick={() => handleClickOpen()}
      >
        {textIcon || Strings.common.delete}
        {showDeleteIcon && <Delete />}
      </Button>
      <Dialog
        sx={{
          '& .MuiDialog-paper': {
            width: '80%',
            maxHeight: 435
          }
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{titleConfirmation}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {textConfirmation}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleDelete()}
            color="success"
            variant="contained"
          >
            {Strings.common.ok}
          </Button>
          <Button
            onClick={() => handleClose()}
            color="error"
            variant="contained"
          >
            {Strings.common.cancel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
